import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-expiration-date-adoption-date",
  // imports: [],
  templateUrl: "./expiration-date-adoption-date.component.html",
  styleUrl: "./expiration-date-adoption-date.component.css",
  standalone: false,
})
export class ExpirationDateAdoptionDateComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
